export enum TaxPayerSource {
    FRONTEND = "FRONTEND",
    HERMES2 = "HERMES2",
    TAX_TINDER = "TAX_TINDER",
}
